document.addEventListener('DOMContentLoaded', function () {
	
	function isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}

	if (document.querySelector('.video-js')) {
		var videos = document.querySelectorAll('.video-js');

		videos.forEach(function (video) {
			var player = videojs(video);
			player.qualityLevels();

			var fullscreen = player.controlBar.getChild("FullscreenToggle");
			var index = player.controlBar.children().indexOf(fullscreen);

			var qualityButton = player.controlBar.addChild("button", {}, index);
			var qualityButtonDom = qualityButton.el();
			qualityButtonDom.innerHTML = "<span class='quality-emoji'>Quality</span>";

			// Create a dropdown menu for quality options
			var qualityMenu = document.createElement('div');
			qualityMenu.className = 'vjs-quality-menu';
			qualityMenu.style.display = 'none';
			player.el().appendChild(qualityMenu);

			// Manually add quality levels using player.options_.sources.
			// Note that is is used as the label
			var qualityLevels = player.qualityLevels();
			player.options_.sources.forEach(function (source, index) {
				var qualityLevel = qualityLevels.addQualityLevel({
					id: source.label,
					label: source.label,
					width: parseInt(source.res, 10),
					height: parseInt(source.res, 10) / (16 / 9),
					bitrate: 1000000, // Replace with actual bitrate
					frameRate: 24, // Replace with actual frame rate
					enabled: function (enabled) {
						if (typeof enabled !== 'undefined') {
							if (enabled) {
								player.src(source.src);
								//player.play();
							}
						} else {
							return false;
						}
					}
				});

				// Create menu item directly for each quality level
				var menuItem = document.createElement('div');
				menuItem.textContent = qualityLevel.label;
				menuItem.className = 'vjs-quality-menu-item';

				menuItem.addEventListener('click', function () {
					qualityLevel.enabled = true;
					for (var i = 0; i < qualityLevels.length; i++) {
						if (qualityLevels[i] !== qualityLevel) {
							qualityLevels[i].enabled = false;
						}
					}
					// Remove 'selected' class from all menu items
					var menuItems = qualityMenu.querySelectorAll('.vjs-quality-menu-item');
					menuItems.forEach(function (item) {
						item.classList.remove('selected');
					});
					// Add 'selected' class to the clicked menu item
					menuItem.classList.add('selected');
					qualityMenu.style.display = 'none';
				});

				qualityMenu.appendChild(menuItem);
			});

			// Add a click event listener to the quality control button
			qualityButtonDom.onclick = function () {
				qualityMenu.style.display = qualityMenu.style.display === 'block' ? 'none' : 'block';
			};

			// Close the menu when clicking outside
			document.addEventListener('click', function (event) {
				if (!qualityButtonDom.contains(event.target) && !qualityMenu.contains(event.target)) {
					qualityMenu.style.display = 'none';
				}
			});

			// Close the menu on video play.
			player.on('play', function () {
				qualityMenu.style.display = 'none';
			});

			// Select initial quality based on device type
			var initialQuality = isMobile() ? 'Ultra' : 'Best'; // Change 'High' and 'Best' to your actual quality labels if needed

			var menuItems = qualityMenu.querySelectorAll('.vjs-quality-menu-item');
			// Find the menu item with the matching label and "click" it to select the quality
			menuItems.forEach(function (item) {
				if (item.textContent === initialQuality) {
					item.click();
				}
			});
			player.ready(function() {
				player.el().classList.remove('initially-hidden'); 
			});
		});
	}

	// Function to set the default country to US
    function setDefaultCountry() {
        // Target the country select boxes on the edit address pages
        const billingCountrySelect = jQuery('#billing_country');
        const shippingCountrySelect = jQuery('#shipping_country');

        // Check if the elements exist
        if (billingCountrySelect.length) {
            // Check if a country is already selected
            if (billingCountrySelect.val() === '') {
                billingCountrySelect.val('US').trigger('change'); // Set to US and trigger change
            }
        }

        if (shippingCountrySelect.length) {
            // Check if a country is already selected
            if (shippingCountrySelect.val() === '') {
                shippingCountrySelect.val('US').trigger('change'); // Set to US and trigger change
            }
        }
    }

    // Call the function when the document is ready
    setDefaultCountry();
});

(function ($) {
	'use strict';

	$(document).ready(function () {

	$('.video-description').on('click', function (e) {
		e.preventDefault();
		const videoId = $(this).data('product');
		const ajaxurl = PWB.ajax_url;
		const data = { 'action': 'pwb_product_description', 'id': videoId, 'nonce': PWB.nonce };
		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: data,
			success: function (result) {
				const modal = new jBox('Modal', {
					width: 500,
					height: 320,
					title: 'Product Info',
					content: result,
					closeButton: "title",
					onCloseComplete: function () {
						modal.destroy();
					},
					animation: "slide"
				});
				modal.open();
			},
		});
		return false;
	});

});

})(jQuery);